import React, { useEffect } from 'react';
import { midas } from '@resurs/midas';
import { classNames } from '@resurs/hephaestus';
const Modal = ({ show, title, actions, onClose, dataCy, hideClose, children, }) => {
    const keyUpListener = (event) => {
        if (event.key === 'Escape') {
            onClose();
        }
    };
    useEffect(() => {
        if (typeof window !== 'undefined') {
            window.addEventListener('keyup', keyUpListener);
        }
        return () => {
            if (typeof window !== 'undefined') {
                window.removeEventListener('keyup', keyUpListener);
            }
        };
    }, []);
    return (React.createElement("div", { className: classNames(midas.modal, show && midas.active), "data-cy": dataCy },
        React.createElement("div", { className: midas.modalOverlay }),
        React.createElement("div", { className: midas.modalContainer, role: "dialog" },
            React.createElement("div", { className: midas.modalHeader },
                React.createElement("h3", null, title),
                !hideClose ? (
                // eslint-disable-next-line jsx-a11y/control-has-associated-label
                React.createElement("button", { type: "button", style: { marginLeft: 'auto' }, className: classNames(midas.button, midas.buttonClear), onClick: onClose })) : null),
            React.createElement("div", { className: midas.modalBody },
                React.createElement("div", null, children)),
            actions && React.createElement("div", { className: midas.modalFooter }, actions))));
};
export default Modal;
